import React, { Component } from 'react';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import $ from 'jquery';

export class VoiceAgent extends Component {
    constructor() {
        super();
        this.state = {
            loadView: false,
            enableVoice: false,
            editButton: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchProjectVoiceSettingApi();
        }, 300);
        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchProjectVoiceSettingApi();
        });
    }

    fetchProjectVoiceSettingApi = () => {
        var thisController = this;
        thisController.state.loadView = false;
        thisController.setState(thisController.state);
        $.ajax({
            url: "/api/voice-settings",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                thisController.state.loadView = true;
                thisController.state.editButton = true;
                if (res.success === true) {
                    if (res.result != null) {
                        thisController.state.enableVoice = res.result.enabled;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.enableVoice = false;
                        thisController.setState(thisController.state);
                    }
                } else {
                    thisController.state.enableVoice = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    checkActivateVoiceHandle = () => {
        if (!this.state.enableVoice) {
            this.state.enableVoice = true;
            this.setState(this.state);
        } else {
            this.state.enableVoice = false;
            this.setState(this.state);
        }
    }

    addProjectVoiceSettingApi = () => {
        var thisController = this;
        let data = {
            "projectId": localStorage.getItem("currentProjectId"),
            "enabled": thisController.state.enableVoice
        }
        $.ajax({
            url: "/api/voice-settings",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
            success: function (res) {
                if (res.success === true) {
                    thisController.fetchProjectVoiceSettingApi();
                    thisController.notifySuccessAck("Added Project Voice Settings Successfully");
                } else {
                    thisController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyError = () => {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyFailToLoad(response) {
        if (/null/i.test(response)) {
            this.notifyError();
        } else {
            toast.dismiss();
            toast(<b style={{ color: "red" }}>{response}</b>, {
                position: "top-center",
                color: "red"

            });
        }
    }

    notifySuccessAck = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center",
        });
    }

    makeEditable = () => {
        this.state.editButton = false;
        this.setState(this.state);
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.loadView}
                    height={300}
                    width={50}
                    style={{ marginLeft: '400px' }}
                />
                <ToastContainer className="Toast-at-center" />

                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <div className="wrapper" style={{ display: this.state.loadView ? 'block' : 'none', height: "430px" }}>
                    <div className="row">
                        <div className="col-12">
                            {/* Custom Tabs */}
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '6px'
                            }}>Enable Voice Agents</h6>

                            <div className="card-body p-0 mb-25" style={{ marginLeft: "6px" }}>
                                <div className="tab-content col-12 p-0">
                                    <div className="tab-pane active show" id="tab_1">
                                        <div className="card card-primary mt-3">
                                            <div className="card-body raise-form">
                                                <div className="col-sm-12">
                                                    <div className="col-sm-7">
                                                        <div className="row col-sm-6" style={{ width: 'auto' }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginTop: '10px', marginLeft: '20px'
                                                            }}>Enable Voice:</h6>
                                                        </div>
                                                        <label class="switch" style={{ marginLeft: '15px', marginTop: '7px' }}>
                                                            <input type="checkbox"
                                                                id={"activateVoiceCapability"}
                                                                disabled={this.state.editButton}
                                                                onChange={this.checkActivateVoiceHandle}
                                                                checked={this.state.enableVoice}
                                                            />
                                                            <span class="slider round" style={{ cursor: this.state.editButton ? 'default' : 'pointer' }}></span>
                                                        </label>
                                                        <h6 style={{ color: '#282a65', marginLeft: '20px', marginTop: '20px' }}>
                                                            You will be charged additional ₹ 2.5 / minute from the time of Deployment as per the usage</h6>
                                                    </div>
                                                    <div className="col-sm-5">
                                                        <button className="btn action-button"
                                                            style={{ marginTop: "10px" }} onClick={this.state.editButton ? this.makeEditable : this.addProjectVoiceSettingApi}>
                                                            {this.state.editButton ? <img className="img-responsive cursor-change" src="./assets/images/editWithWhiteFilled.png" /> : "Save"}</button>
                                                        <button className="btn action-button" style={{ marginTop: "10px", marginLeft: "0px" }}
                                                            title="Refresh" onClick={this.fetchProjectVoiceSettingApi}>
                                                            <img src="./assets/images/refresh_white_24dp.png" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/VoiceAgent.js